import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Malindi8";

const MalindiPhase8 = () => {
  const project_id = "PRJ00074";
  const title = "Malindi Phase 8";

  const mapConfig = {
    minZoom: 10,
    zoom: 16,
    bounds: [
      [-1.34507, 36.59725],
      [-1.37433, 36.6327],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={project_id}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/malindi-gardens-phase-8/"
      // Offer link was commented out
      fillOfferLink={null}
    />
  );
};

export default MalindiPhase8;
